import * as React from 'react';
import { Flex } from '@packages/ui';
import { ButtonVariant } from '@packages/ui/components/buttons/types';
import { FontWeight } from '@packages/ui/theme/font';
import { ResponsiveValue } from 'styled-system';
import { MessageBannerButton } from './MessageBannerStyleComponents';
import { LinkTarget, SmartLink } from '../../SmartLink';

export interface MessageBannerProps {
  onClick: VoidFunction;
  text: string;
  fontSize: ResponsiveValue<number | string>;
  fontWeight: FontWeight;
  backgroundColor: string;
  fontColor: string;
  button?: {
    variant: ButtonVariant;
    text: string;
    linkUrl: string;
    linkTarget: LinkTarget;
  };
}

export const MessageBanner: React.FC<MessageBannerProps> = ({
  text,
  fontSize,
  fontWeight,
  backgroundColor,
  fontColor,
  button,
  onClick,
}) => {
  return (
    <Flex
      backgroundColor={backgroundColor}
      px={4}
      py={3}
      flexDirection="row"
      justifyContent="center"
      textAlign="center"
    >
      <Flex
        fontSize={fontSize}
        flexDirection="column"
        justifyContent="center"
        color={fontColor}
        fontWeight={fontWeight}
        lineHeight={1.2}
      >
        {text}
      </Flex>
      {button && (
        <Flex onClick={onClick} flexDirection="column" justifyContent="center" ml={4}>
          <SmartLink linkUrl={button.linkUrl} target={button.linkTarget}>
            <MessageBannerButton variant={button.variant} color={backgroundColor}>
              {button.text}
            </MessageBannerButton>
          </SmartLink>
        </Flex>
      )}
    </Flex>
  );
};
